<template>
<v-card :color="is_active ? 'primary' : 'secondary'" outlined dark :loading="saving || deleting">
    <v-card-title class="py-1 px-2 d-flex justify-space-between align-center">
        <div class="d-flex align-center">
            <v-checkbox class="ma-0" v-model="is_active" hide-details color="white" :disabled="saving || deleting" dense/>
            <div class="mt-1 text-overline">{{ juegoSet.juego.name }}</div>
        </div>
        <div class="d-flex">
            <v-btn
                small
                class="mr-2"
                :disabled="saving || deleting"
                :loading="deleting"
                @click="remove"
                text
                >
                <v-icon small>mdi-delete</v-icon>
            </v-btn>
            <v-btn
                small
                :disabled="saving || deleting || !canSave"
                :loading="saving"
                @click="save"
                >
                <v-icon small>mdi-content-save</v-icon>
            </v-btn>
        </div>
    </v-card-title>
    <v-divider/>
    <v-card-text class="d-flex pa-2">
        <ListItemForm
            :loading="saving || deleting"
            v-model="juegoSetData"
            :default="defaultJuegoSetData"
            :valid.sync="isJuegoSetValid"
            :context="context"/>
    </v-card-text>
</v-card>
</template>
<script>

import JuegoSetService from '@/services/operadora/institution/JuegoSetService';

import ListItemForm from './list.item.form.vue';

export default {
    components: {
        ListItemForm
    },
    props: {
        user: {
            required: true,
        },
        juegoSet: {
            required: true,
        },
    },
    data: function () {
        return {
            is_active: true,

            saving: false,
            deleting: false,

            context: 'new',
            juegoSetData: {},
            defaultJuegoSetData: {
            },
            isJuegoSetValid: false,
        };
    },
    computed: {
        canSave: function () {
            return this.isJuegoSetValid;
        }
    },
    methods: {
        remove: async function () {
            if (!this.juegoSet.id) {
                return this.$emit('deleted', { ... this.juegoSet});
            }

            this.deleting = true;

            try {
                await JuegoSetService.delete(this.user.id, this.juegoSet.juego_id);
                this.deleting = false;
                this.$emit('deleted', { ... this.juegoSet});
            } catch (error) {
                // TODO: IMPLEMENT
            }

            this.deleting = false;
        },
        save: async function () {
            if (!this.canSave) return;

            this.saving = true;

            try {
                const { juegoSet } = await JuegoSetService.set(this.user.id, this.juegoSet.juego_id, {
                    is_active: this.is_active,
                    ... this.juegoSetData,
                });
                this.$emit('saved', { ... juegoSet});
            } catch (error) {
                // TODO: IMPLEMENT
            }

            this.saving = false;
        },
        setIsActive: async function () {
            if (!this.juegoSet.id) return;

            this.saving = true;

            try {
                const { juegoSet } = await JuegoSetService.set(this.user.id, this.juegoSet.juego_id, {
                    is_active: this.is_active,
                });
                this.$emit('saved', { ... juegoSet});
            } catch (error) {
                // TODO: IMPLEMENT
            }

            this.saving = false;
        }
    },
    watch: {
        is_active: function () {
            this.setIsActive();
        },
      canSave: function (canSave) {
          console.log(canSave);
      }
    },
    mounted: function () {
        if (this.juegoSet) {
            this.context = 'edit';
            this.defaultJuegoSetData = { ... this.juegoSet };
            this.is_active = this.juegoSet.is_active;
        } else {
            this.context = 'new';
            this.defaultJuegoSetData = {};
        }
        this.juegoSetData = {};
    }
}
</script>